import { Component } from '@angular/core';

interface NavItem {
  path: string;
  label: string;
  verified?: boolean;
}

@Component({
  selector: 'app-ui-kit-layout',
  templateUrl: './ui-kit-layout.component.html',
  styleUrls: ['./ui-kit-layout.component.scss'],
})
export class UiKitLayoutComponent {
  readonly navItems: NavItem[] = [
    { path: 'foundations',                   label: 'Foundations' },
    { path: 'info-chip',                     label: 'Chip / Info chip',                  verified: true },
    { path: 'buttons',                       label: 'Botones' },
    { path: 'toggle',                        label: 'Toggle' },
    { path: 'text-field',                    label: 'Text field',                         verified: true },
    { path: 'time-field',                    label: 'Time input field',                    verified: true },
    { path: 'filter-fields',                 label: 'Filter fields',                      verified: true },
    { path: 'text-area-field',               label: 'Text area (Froala)',                 verified: true },
    { path: 'select-field',                  label: 'Select field',                       verified: true },
    { path: 'tabs',                          label: 'Tabs' },
    { path: 'badge',                         label: 'Badge' },
    { path: 'tooltip',                       label: 'Tooltip' },
    { path: 'card',                          label: 'Card' },
    { path: 'checkbox',                      label: 'Checkbox' },
    { path: 'checkbox-list',                 label: 'Checkbox list',                        verified: true },
    { path: 'icon-button',                   label: 'Icon button',                        verified: true },
    { path: 'icon-area-card',                label: 'Icon area card',                     verified: true },
    { path: 'area-card',                     label: 'Area card',                          verified: true },
    { path: 'area-reserva-reglas',           label: 'Área · reglas (ejemplo)' },
    { path: 'pagination-buttons',            label: 'Pagination buttons' },
    { path: 'avatar',                        label: 'Avatar',                             verified: true },
    { path: 'area-picture-uploader',         label: 'Area picture uploader',              verified: true },
    { path: 'title-preview',                 label: 'Title preview',                      verified: true },
    { path: 'input-preview',                 label: 'Input preview',                      verified: true },
    { path: 'reservation-review-card',       label: 'Reservation review card' },
    { path: 'area-picture-uploader-gallery', label: 'Area picture uploader — Gallery' },
    { path: 'image-preview-icon-action',     label: 'Image preview + icon action' },
    { path: 'panel',                         label: 'Panel',                              verified: true },
    { path: 'toggle-panel',                  label: 'Toggle panel',                       verified: true },
    { path: 'schedule-card',                 label: 'Schedule card',                      verified: true },
    { path: 'alert',                         label: 'Alert',                              verified: true },
    { path: 'notification-card',             label: 'Notification card' },
  ];
}